var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHoffmannGroupBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "40px",
    viewBox: "0 0 47 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Hoffmann-Group-pictorial_black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hoffmann-Group-pictorial_orange",
    transform: "translate(0.000000, 0.000001)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4095661,23.7572617 L17.0337918,30.0756805 L17.7650714,31.1366128 L17.7650714,39.9922581 L24.4677758,39.9922581 L24.4677758,28.1854334 L21.4095661,23.7572617 Z M31.8940518,4.42746645 C31.8940518,1.98246657 29.9383693,0 27.525982,0 C25.1136012,0 23.1579154,1.98246649 23.1579154,4.42746645 C23.1579154,6.8724664 25.1136012,8.85493843 27.525982,8.85493843 C29.9383692,8.85493843 31.8940518,6.87246859 31.8940518,4.42746645 M39.787539,28.489565 L44.089764,30.196769 L39.5696961,31.2886754 L41.0364604,35.7569783 L37.2049442,32.8832405 L34.4766496,36.8298789 L34.4745502,32.0722303 L29.8171892,32.4115592 L33.433666,29.4667192 L30.2360672,26.0149959 L34.8668087,27.0280535 L35.5847801,22.2485831 L37.6945665,26.5929815 L41.8398875,24.255694 L39.787539,28.489565 Z M46.9798656,29.6715826 C46.9798656,25.2835358 44.255776,21.5375424 40.4158528,20.0408305 C39.2649992,19.5839334 38.0125735,19.3304925 36.7013146,19.3304925 C35.4979228,19.3304925 34.3449634,19.545917 33.273261,19.9352323 C33.2200252,19.9542397 33.1667894,19.9725427 33.1142544,19.9922562 C33.1051498,19.995775 33.0960451,19.9985925 33.0876381,20.0021128 L27.525982,11.9511423 L26.8556459,11.0007373 C26.0557182,9.97923025 24.8334162,9.32802866 23.4465041,9.32802866 C21.9636298,9.32802866 20.6537696,10.0777902 19.6177897,11.5871716 C19.3705272,11.9511422 0,39.9922581 0,39.9922581 L8.15615964,39.9922581 L24.4677764,16.3786102 L28.9619289,22.8842968 C27.384491,24.6992139 26.4269648,27.0724078 26.4269648,29.6715826 C26.4269648,35.3754113 31.0282849,40 36.7034148,40 C42.3792447,40 46.9798656,35.3754114 46.9798656,29.6715826 Z",
    id: "Shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoffmannGroupBlack);
export default __webpack_public_path__ + "static/media/hoffmann-group-black.b681d3b64010fe1baf175339cfe7bb11.svg";
export { ForwardRef as ReactComponent };